import React from "react";
import ReactDOM from "react-dom";
import "./custom.scss";
// Put any other imports below so that CSS from your
// components takes precedence over default styles.
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
